// extracted by mini-css-extract-plugin
export default {"productGallery":"LI-z","inQuickShop":"MI-z"};